import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

const ContenutoCorpus = ({ docStip }) => {
 console.log(docStip)
 return ( 
  <Container className='articoloBoxDesktop'>
      <div className="content post_content" dangerouslySetInnerHTML={{ __html: 
       `
       <h3>Lista dei documenti da portare per la stipula di "${docStip.name}"</h3>
       <p>
        In questa pagina elenchiamo i documenti utili alla stipula di <strong>${docStip.name}</strong>. La lista può essere stampata e utilizzata come promemoria.
        Eventuali ulteriori documenti saranno richiesti successivamente dallo studio notarile Falcinelli.
       </p>
       <p>
        Si tratta di una lista di documenti scaricabile direttamente dall'interfaccia inedita che lo <strong>Studio Notarile Falcinelli</strong> mette a disposizione sul suo sito.
       </p>
       
       <h3>Documenti per la stipula di ${docStip.name}</h3>
       ` + docStip.corpus +
       `
       <h3>Notaio a Treviso - Studio Notarile Falcinelli</h3>
       <p>
       Qui potete scaricare i principali documenti occorrenti per le pratiche notarili più frequenti, con la precisazione che i documenti richiesti vanno poi verificati in relazione allo specifico atto.
       </p>
       `
       }}></div>
  </Container>
  );
}

export default ContenutoCorpus;

